import _ from 'lodash';
import store from '../../store';
import { OVERVIEW_PANEL_GET_CURRENT, OVERVIEW_PANEL_IS_VISIBLE } from '../../store/modules/overview-panel/types';
import worldMap from '../core/map';
import { pinBuilder } from '../core/map/pinBuilder';
import ColorBrewer from '../core/tools/colorbrewer';
import environment from '../environment';
import Leaflet from './Leaflet';
import templates from '../core/templates';
import { VehicleTypeEnum } from '../core/vehicleType/constants';
import { StoreTypeEnum } from '../../enuns/store.enun';

const LayerControls = (name) => require('../controls').get(name);
const get = (name, currentMap = worldMap.getCurrent()) => {
    return require('./index').default.get(name, currentMap);
};

const name = 'ClusterSales';

class ClusterSalesLayer {
    constructor (currentMap) {
        let _total = 0;
        const mapId = +currentMap._id;

        const clusterImage = new Image();
        clusterImage.src = `${environment.get('IMAGES_HOST')}/icon_marker_points.png`;

        const clusterTemplate = (cluster) => {
            var features = cluster.getAllChildMarkers().filter(f => f.feature.properties.IdTipoLoja !== StoreTypeEnum.Oficina);

            if (!_total) {
                _total = Math.round(_.sumBy(get('ClusterSales', currentMap).getCurrentFeatures(), 'properties.MediaMensal'));
            }
            const data = {
                total: _total,
                value: Math.round(_.sumBy(features, 'feature.properties.MediaMensal'))
            };
            if (data.value === 0) {
                return L.icon({
                    iconUrl: `${environment.get('IMAGES_HOST')}/icon_blank.png`,
                    iconSize: L.point(0, 0),
                    iconAnchor: [0, 0]
                });
            }

            return pinBuilder.create.pin.imageWithValue(data, clusterImage);
        };

        const onComplete = () => {
            _total = 0;

            if (store.getters[OVERVIEW_PANEL_GET_CURRENT] === name && store.getters[OVERVIEW_PANEL_IS_VISIBLE] && LayerControls(name).getControls(mapId).button.overview.enable) {
                LayerControls(name).toggleOverview();
            }
        };

        const onSuccess = res => {
            res = {
                ...res,
                features: res.features.map(f => ({
                    ...f,
                    properties: {
                        ...f.properties,
                        MediaMensal: Math.round(f.properties.MediaMensal)
                    }
                }))
            };

            return new Promise(resolve => {
                resolve(res);
            });
        };

        return new Leaflet.D3Layer({
            map: currentMap,
            remote: {
                method: 'POST',
                url: `${environment.get('API_HOST')}/lojaconcessionaria/obterdadosclustervendas`,
                params: {
                    bandeiras: (() => {
                        let flags = [];
                        _.forEach(environment.get('CONFIG.DEALERS'), flag => flags.push(flag));
                        _.forEach(environment.get('CONFIG.COMPETITORS'), flag => flags.push(flag));

                        return flags.join(',');
                    })(),
                    ...LayerControls(name).dateApiParams,
                    bbox: 'LINESTRING(-13.095703125 5.266007882805511, -86.923828125 -33.46810795527895)'
                }
            },
            filter: {
                location: true
            },
            showAll: true,
            uniqueField: 'Id',
            done: onComplete,
            success: onSuccess,
            type: 'heat',
            symbology: {
                type: 'single',
                cluster: {
                    template: clusterTemplate,
                    force: true
                },
                heat: {
                    theme: ColorBrewer.getHeatColors(ColorBrewer.RED_YELLOW_BLUE),
                    property: 'MediaMensal'
                },
                style: {}
            },
            popup: {
                trigger: 'mouseover',
                clusterTemplate (features) {
                    const featuresFilted = features.filter(f => f.feature.properties.IdTipoLoja !== StoreTypeEnum.Oficina);

                    if (!featuresFilted.length) {
                        return;
                    }

                    const layerControls = LayerControls(name);
                    const layerType = layerControls.getControls(mapId).buttonGroup.layerType.type;
                    if (layerType === 'decluster') {
                        this.options.offset = L.point(0, -16);
                    } else {
                        this.options.offset = L.point(0, -50);
                    }
                    return new Promise((resolve, reject) => {
                        const _totalSales = _.sumBy(featuresFilted, 'feature.properties.Total');
                        const _totalStores = _.size(featuresFilted);
                        const getIconPath = (brandName) => {
                          return environment.get('CONFIG.USERVEHICLETYPE') === VehicleTypeEnum.Moto
                            ? `${environment.get('IMAGES_HOST')}/motos/logo_${String(brandName).toUnderscoreCase()}.png`
                            : `${environment.get('IMAGES_HOST')}/logo_${String(brandName).toUnderscoreCase()}.png`;
                        };

                        const brands = _(featuresFilted)
                            .groupBy('feature.properties.Brand')
                            .map((v, k) => {
                                const mediaMensal = _.sumBy(v, 'feature.properties.MediaMensal');
                                return {
                                    icon: getIconPath(String(k).toUnderscoreCase()),
                                    sales: mediaMensal,
                                    salesPerBrand: mediaMensal / _.size(v),
                                    total: _.size(v),
                                    name: k.toCapitalCase()
                                };
                            })
                            .orderBy('sales', ['desc'])
                            .value();

                        const values = {
                            brands,
                            period: layerControls.currentPeriod,
                            totalBrands: _.size(brands),
                            totalStores: _totalStores,
                            totalAvgSalesInCluster: _.sumBy(brands, 'sales'),
                            totalAvgSales: _.sumBy(brands, 'sales') / _totalStores,
                            totalSales: _totalSales,
                            salesEfficiency: _totalSales
                        };

                        const template = $(templates('map-layer-stores-cluster-popup', values));
                        resolve(template);
                    });
                },
                options: {
                    offset: L.point(0, -16),
                    closeButton: false,
                    autoclose: true
                },
                single: true
            }
        });
    }
}

export default ClusterSalesLayer;



// WEBPACK FOOTER //
// ./src/scripts/layers/ClusterSalesLayer.js